// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_j9-0";
export var actionModalContentContainer = "_j9-1";
export var createTagButton = "_j9-2";
export var footerContainer = "_j9-7";
export var fullWidthDivider = "_j9-3";
export var hasCreateTagButton = "_j9-4";
export var noCreateTagButton = "_j9-5";
export var tagsContainer = "_j9-6";
export var tagsModalContentContainer = "_j9-8";